<div class="layout-header" [ngClass]="{'not-changeable': !isHome()}">
    <div class="image-container" [class.rounded]="selectedAppType === appTypeEnum.binding">
        <img [routerLink]="['/home']" src="/assets/images/LogoNew.svg" id="header-img" alt="logo">
    </div>
    
    @for (appType of appTypes; track $index) {
    @if(appType.isVisible){
    <div class="app-type" [ngClass]="{'active': selectedAppType === appType.type}" (click)="setAppType(appType.type)">
        <div>{{appType.title}}</div>
    </div>
    }
    }

</div>